var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Grid_icon","data-name":"Grid icon","d":"M14,43V38H45v5H14Zm0-15H45v5H14V28Zm0-10H45v5H14V18Z"}));
}

IconMenu.defaultProps = {"fill":"#fff","width":"30","height":"30","viewBox":"15 15 30 30","preserveAspectRatio":"xMinYMin slice"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
